// Base Styles
import colors from "assets/mavric-theme/base/colors";
import typography from "assets/mavric-theme/base/typography";

// Helper Functions
import pxToRem from "assets/mavric-theme/functions/pxToRem";

const { white, text, info, secondary, primary } = colors;
const { size } = typography;

const contained = {
  base: {
    backgroundColor: secondary.main,
    minHeight: pxToRem(40),
    // color: text.main,
    color: white,
    padding: `${pxToRem(10)} ${pxToRem(24)}`,

    "&:hover": {
      backgroundColor: white.main,
    },

    "&:active, &:active:focus, &:active:hover": {
      opacity: 0.85,
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },

    "&:disabled": {
      backgroundColor: white.main,
    },
  },

  small: {
    minHeight: pxToRem(32),
    //padding: `${pxToRem(6)} ${pxToRem(16)}`,
    fontSize: size.xs,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(47),
    padding: `${pxToRem(12)} ${pxToRem(28)}`,
    fontSize: size.sm,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: {
    backgroundColor: primary.light,

    "&:hover": {
      backgroundColor: primary.light,
    },

    "&:focus:not(:hover)": {
      backgroundColor: primary.light,
    },
  },

  secondary: {
    backgroundColor: secondary.main,

    "&:hover": {
      backgroundColor: secondary.main,
    },

    "&:focus:not(:hover)": {
      backgroundColor: secondary.main,
    },
  },
};

export default contained;
